import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'

// services
import { AuthService } from '@/services'

// models
import { AuthResponse, AuthLogin, AuthResponseService, UserLogin } from '@/models'

const tokenUser = localStorage.getItem('token_aqua')
const typeToken = localStorage.getItem('type_token')
const tokenExpiresIn = localStorage.getItem('token_expires_in')
const userAuth = localStorage.getItem('user')
const loggeIn = tokenUser != null && userAuth != null

@Module({ namespaced: true })
class AuthStore extends VuexModule {
	public loggeIn = loggeIn
	public tokenExpiresIn = tokenExpiresIn
	public user = tokenUser && userAuth ? JSON.parse(String(userAuth)) : null

	get isLoggeIn (): boolean {
		return this.loggeIn
	}

	get auth (): UserLogin {
		return this.user
	}

	get token (): string|null {
		return typeToken + ' ' + tokenUser
	}

	@Mutation
	public loginFailure (): void {
		this.loggeIn = false
		this.user = null
	}

	@Mutation
	public detroyToken (): void {
		localStorage.removeItem('token_aqua')
		localStorage.removeItem('user')
		localStorage.removeItem('type_token')
		localStorage.removeItem('refresh_token')
		localStorage.removeItem('token_expires_in')
	}

	@Mutation
	public loginSuccess (dataLogin: AuthResponseService): void {
		this.loggeIn = true
		this.user = dataLogin.user
		localStorage.setItem('token_aqua', dataLogin.token)
		localStorage.setItem('refresh_token', dataLogin.refreshToken)
		localStorage.setItem('type_token', dataLogin.typeToken)
		localStorage.setItem('token_expires_in', String(dataLogin.expiresIn))
		localStorage.setItem('user', JSON.stringify(dataLogin.user))
	}

	@Action
	public async login (form: AuthLogin): Promise<AuthResponse> {
		try {
			const user: AuthResponseService = await AuthService.login(form)
			this.context.commit('loginSuccess', user)
			return {
				success: true,
				msg: 'Acceso con éxito'
			}
		} catch (error) {
			this.context.commit('loginFailure')
			return {
				success: false,
				msg: 'Credenciales de Acceso Inválidas'
			}
		}
	}

	@Action
	public async logout (): Promise<AuthResponse> {
		await AuthService.logout()
		this.context.commit('detroyToken')
		return {
			success: true,
			msg: ''
		}
	}
}

export default AuthStore
